/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetOrderResult } from '../../models/get-order-result';

export interface GetByOrderid$Params {
  OrderId: number;
}

export function getByOrderid(
  http: HttpClient,
  rootUrl: string,
  params: GetByOrderid$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<GetOrderResult>> {
  const rb = new RequestBuilder(rootUrl, getByOrderid.PATH, 'get');
  if (params) {
    rb.path('OrderId', params.OrderId, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetOrderResult>;
    }),
  );
}

getByOrderid.PATH = '/Orders/{OrderId}';
